import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"
import StyledButton from "common/views/components/StyledButton"
import styled from "styled-components"

export const TextButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex-direction: row;
     justify-content: space-between;
     flex-grow: 1;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 30px;
`

export const SettlementButton = styled(StyledButton)`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  @media screen and ${DESKTOP_BREAKPOINT} {
    margin-top: 48px;
    margin-left: auto;
  }
`
